import Cookies from 'universal-cookie'

const cookies = new Cookies();


const defaultState = {
    asciiDocHtml:'',
    menuAdocs: {}
};

export default function Asciidoc(state = defaultState, action) {

  switch (action.type) {
    case "GET_ASCIIDOC_SUCCESS": {

      return {
        ...state,
        asciiDocHtml:action
      };
    }
    case "GET_ASCIIDOC_ERROR": {

      console.log("GET_ASCIIDOC_ERROR",action);
      return {
        ...state,
          asciiDocHtml:'error'
      };
    }

      case "GET_MENU_ASCIIDOC_SUCCESS": {

          cookies.set('menu_adocs', action.results);

          return {
              ...state,
              menuAdocs:action
          };
      }
      case "GET_MENU_ASCIIDOC_ERROR": {

          console.log("GET_ASCIIDOC_ERROR",action);
          return {
              ...state,
              menuAdocs:'error'
          };
      }

    default: return state;
  }
}
